import api from './api';

export interface Region {
  id: number;
  nombre: string;
  codigo: string;
}

export interface Comuna {
  id: number;
  nombre: string;
  region_id: number;
  region_nombre: string;
}

// Obtener todas las regiones
export const getRegiones = async (): Promise<Region[]> => {
  try {
    const response = await api.get('/auth/regiones/');
    const data = response.data;
    
    // Sin paginación, la API devuelve directamente un array
    const regiones = Array.isArray(data) ? data : [];
    
    console.log('🗺️ Total regiones cargadas desde API:', regiones.length);
    
    return regiones;
  } catch (error) {
    console.error('❌ Error al cargar regiones:', error);
    return [];
  }
};

// Obtener todas las comunas (sin paginación)
export const getComunas = async (): Promise<Comuna[]> => {
  try {
    const response = await api.get('/auth/comunas/');
    const data = response.data;
    
    // Sin paginación, la API devuelve directamente un array
    const comunas = Array.isArray(data) ? data : [];
    
    console.log('🌍 Total comunas cargadas desde API:', comunas.length);
    
    return comunas;
  } catch (error) {
    console.error('❌ Error al cargar comunas:', error);
    return [];
  }
};

// Obtener comunas por región
export const getComunasByRegion = async (regionId: number): Promise<Comuna[]> => {
  const response = await api.get<Comuna[]>(`/auth/comunas/?region=${regionId}`);
  return response.data;
};

// Obtener una región por nombre (útil para conversión)
export const getRegionByNombre = (regiones: Region[], nombre: string): Region | undefined => {
  return regiones.find(region => region.nombre === nombre);
};
